<template>
  <div class="z-border-red px-2 mb-2" style="position: relative">
    <v-btn
      fab
      depressed
      @click="$emit('onDelete')"
      small
      class="extra-small"
      color="primary"
      style="position: absolute; top: 0; right: 0; margin-top: -15px; margin-right: -15px"
    >
      <em class="fa fa-trash middle" />
    </v-btn>

    <v-layout wrap>
      <!-- <v-flex xs12 sm1>
        <move-vertical slot="move" :index="index" :max="max" @onMove="onMove"></move-vertical>
      </v-flex>-->
      <v-flex xs12 sm3 class="form-control px-2 py-3 pr-3" style="border-right: solid 1px #e3e3e3">
        <input
          type="text"
          @input="stock[3] = $event.target.value.toUpperCase()"
          style="text-transform: uppercase"
          :name="'keyword_' + index"
          :data-vv-name="'keyword_' + index"
          :data-vv-as="$t('keyword')"
          v-validate="`required|excluded:${excludekeywordname}`"
          class="form-control"
          id="keyword"
          :placeholder="$t('Keyword') + ' *'"
          v-model="stock[3]"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control px-2 py-3 pl-3">
        <input
          type="text"
          :name="'option_' + index"
          :data-vv-name="'option_' + index"
          :data-vv-as="$t('option')"
          v-validate="`required|excluded:${excludestockname}`"
          class="form-control"
          id="optionInput"
          :placeholder="$t('option') + ' ' + $t('EX.Size, Color, Weight') + ' *'"
          v-model="stock[1]"
        />
      </v-flex>
      <!-- <v-flex xs12 sm3 class="form-control  px-2 py-3">
        <input
          type="text"
          :name="'sku_' + index"
          :data-vv-name="'sku_' + index"
          :data-vv-as="$t('SKU') + ' (Optional)'"
          class="form-control"
          id="skuInput"
          :placeholder="$t('SKU') + ' (Optional)'"
          v-model="stock[2]"
        />
      </v-flex>-->

      <v-flex xs12 sm2 class="form-control px-2 py-3">
        <input
          type="number"
          :name="'quantity_' + index"
          :data-vv-name="'quantity_' + index"
          :data-vv-as="$t('quantity')"
          v-validate="'required|numeric'"
          maxlength="4"
          pattern="[0-9]*"
          inputmode="numeric"
          class="form-control"
          id="quantityInput"
          :placeholder="$t('quantity') + ' *'"
          v-model="stock[4]"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control px-2 py-3">
        <input
          type="number"
          :name="'discountprice_' + index"
          :data-vv-name="'discountprice_' + index"
          :data-vv-as="$t('Discount')"
          v-validate="'decimal:2|min_value:0'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          id="priceInput"
          :placeholder="$t('Discount')"
          v-model="stock[6]"
          @blur="onBlurPrice"
        />
      </v-flex>
      <v-flex xs12 sm2 class="form-control px-2 py-3">
        <input
          type="number"
          :name="'price_' + index"
          :data-vv-name="'price_' + index"
          :data-vv-as="$t('Price')"
          v-validate="'decimal:2|min_value:1|required'"
          pattern="[0-9]*"
          maxlength="13"
          inputmode="numeric"
          class="form-control"
          id="priceInput"
          :placeholder="$t('Price') + ' *'"
          v-model="stock[5]"
          @blur="onBlurPrice"
        />
      </v-flex>

      <v-flex xs12>
        <div
          class="form-control"
          :class="{
            'has-error':
              errors.has('option_' + index) ||
              errors.has('quantity_' + index) ||
              errors.has('price_' + index) ||
              errors.has('keyword_' + index)
          }"
        >
          <span class="text-error" v-if="errors.has('option_' + index)">{{
            errors.first('option_' + index)
          }}</span>
          <span class="text-error" v-else-if="errors.has('quantity_' + index)">{{
            errors.first('quantity_' + index)
          }}</span>
          <span class="text-error" v-else-if="errors.has('price_' + index)">{{
            errors.first('price_' + index)
          }}</span>
          <span class="text-error" v-else-if="errors.has('keyword_' + index)">{{
            errors.first('keyword_' + index)
          }}</span>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import MoveVertical from '@/components/elements/MoveVertical'
export default {
  inject: ['parentValidator'],
  props: ['value', 'index', 'max', 'productstock', 'stockkey', 'products', 'productskey'],
  created() {
    this.$validator = this.parentValidator
  },
  data: function () {
    return {
      // stock: this.value
    }
  },
  components: {
    MoveVertical
  },
  computed: {
    stock() {
      return this.value
    },
    excludestockname() {
      return this.productstock.filter((el, index) => index != this.stockkey).map((v) => v[1])
    },
    excludekeywordname() {
      var result = []
      this.products
        ? this.products
        : []
            .filter((el, index) => el.id != this.productskey)
            .map((v) => {
              result.push(v.keyword)
              result = [...v.productstock.map((el) => el[3]), ...result]
            })
      result = [
        ...this.productstock.filter((el, index) => index != this.stockkey).map((v) => v[3]),
        ...result
      ]
      return result.map((el) => (el ? el.toUpperCase() : el))
    }
  },
  methods: {
    onMove: function (payload) {
      this.$emit('onMove', payload)
    },
    onBlurPrice: function () {
      // this.$set(this.stock, 4, this.stock[3])
    }
  },
  watch: {
    // stock: function() {
    //   this.stock = this.value
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/live/ProductStockItem.vue